import React from 'react';

interface SectionHeaderProps {
  /** Uppercase subtype label shown in purple, e.g. "Multiple Choice Question" */
  title: string;
  /** @deprecated trash lives inside the Question field, not the header */
  onDelete?: () => void;
  className?: string;
}

/**
 * SectionHeader — centered uppercase purple h4 heading above each item editor.
 * Matches Figma node 11126:525030 (MC question section title).
 */
export default function SectionHeader({ title, className = '' }: SectionHeaderProps) {
  return (
    <div className={`w-full ${className}`}>
      <h4 className="m-0 text-center font-sans font-bold text-xl leading-9 uppercase tracking-normal text-primary-500">
        {title}
      </h4>
    </div>
  );
}
